import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { submitSurveyFeedback } from "../../pages/confirmation/actions";
import ReportWrapper from "./component";

const mapStateToProps = ({ funnelStep }) => ({ funnelStep });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      SubmitSurveyFeedbackConnect: submitSurveyFeedback,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ReportWrapper);
